import api from "@/core/services/api.service";

const evntsService = {
    
    get(params) {
        api.setHeader()
        return api.post("api/event", params)
    },

}

export default evntsService